import React, { useState, useEffect } from "react";
import AffiliateLayout from "./layout";
import axios from "axios";
import { END_POINT } from "../../constants/defaultValues";
import { NotificationManager } from "../../components/common/react-notifications";
import { GetBank } from "../../helpers/ListBank";
import moment from "moment";

const Payouts = () => {
  const [amount, setAmount] = useState("");
  const [balance, setBalance] = useState(0);
  const [bankInfo, setBankInfo] = useState(null);
  const [payoutHistory, setPayoutHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("affiliate_token");
      const headers = { "x-auth-token": token };

      const [profileRes, historyRes] = await Promise.all([
        axios
          .get(`${END_POINT}/api/affiliate/profile`, { headers })
          .catch((err) => ({ status: 500, data: { data: {} } })),
        axios
          .get(`${END_POINT}/api/affiliate/payouts`, { headers })
          .catch((err) => ({ status: 500, data: { data: [] } })),
      ]);

      if (profileRes.status === 200) {
        const data = profileRes.data.data || profileRes.data;
        setBalance(parseFloat(data.balance) || 0);
        if (data.bank_name && data.bank_number) {
          const bankData = GetBank(data.bank_name);
          const bankLabel = bankData ? bankData.label : data.bank_name;
          setBankInfo(`${bankLabel} - ${data.bank_number}`);
        }
      }

      if (historyRes.status === 200) {
        setPayoutHistory(historyRes.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRequest = async (e) => {
    e.preventDefault();
    if (parseInt(amount) < 1000000) {
      NotificationManager.warning(
        "Số tiền rút tối thiểu là 1.000.000đ",
        "Cảnh báo",
        3000,
      );
      return;
    }

    if (parseInt(amount) > balance) {
      NotificationManager.error("Số dư không đủ", "Lỗi", 3000);
      return;
    }

    if (!bankInfo) {
      NotificationManager.error(
        "Vui lòng cập nhật ngân hàng trong phần Cài đặt",
        "Lỗi",
        3000,
      );
      return;
    }

    try {
      const token = localStorage.getItem("affiliate_token");
      const res = await axios.post(
        `${END_POINT}/api/affiliate/payouts`,
        { amount: parseInt(amount) },
        { headers: { "x-auth-token": token } },
      );

      if (res.status === 201) {
        NotificationManager.success(
          "Gửi yêu cầu thành công!",
          "Thành công",
          3000,
        );
        setAmount("");
        fetchData(); // Reload data
      }
    } catch (error) {
      console.error(error);
      NotificationManager.error(
        error.response?.data?.responseText || "Lỗi gửi yêu cầu",
        "Lỗi",
        3000,
      );
    }
  };

  const formatCurrency = (val) => {
    return new Intl.NumberFormat("vi-VN").format(val);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "paid":
        return <span className="status-badge paid">Thành công</span>;
      case "pending":
        return <span className="status-badge pending">Chờ xử lý</span>;
      case "rejected":
        return <span className="status-badge rejected">Từ chối</span>;
      default:
        return <span className="status-badge">{status}</span>;
    }
  };

  return (
    <AffiliateLayout title="Rút tiền">
      <div className="aff-page-container">
        <div className="page-header">
          <h2>Yêu cầu thanh toán</h2>
          <p>
            Quản lý và tạo yêu cầu rút tiền hoa hồng về tài khoản ngân hàng.
          </p>
        </div>

        <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
          {/* Request Form */}
          <div className="aff-card" style={{ flex: "1", minWidth: "300px" }}>
            <div className="card-header">
              <h3>Tạo yêu cầu mới</h3>
            </div>
            <div className="card-body">
              <div className="mb-6 p-4 bg-emerald-50 rounded-lg border border-emerald-100">
                <p className="text-sm text-emerald-800 mb-1">Số dư khả dụng</p>
                <p className="text-2xl font-bold text-emerald-600 font-mono">
                  {formatCurrency(balance)}{" "}
                  <span className="text-sm font-sans">đ</span>
                </p>
              </div>

              <form onSubmit={handleRequest}>
                <div className="form-group">
                  <label>Số tiền muốn rút</label>
                  <input
                    type="number"
                    placeholder="Nhập số tiền (tối thiểu 1.000.000đ)"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                  <p className="helper-text">Phí giao dịch: Miễn phí</p>
                </div>
                <div className="form-group">
                  <label>Ngân hàng nhận</label>
                  <select
                    disabled
                    className="bg-slate-50 cursor-not-allowed"
                    value={bankInfo ? "exist" : ""}
                  >
                    <option value="">
                      {bankInfo || "Chưa cập nhật tài khoản ngân hàng"}
                    </option>
                    {bankInfo && <option value="exist">{bankInfo}</option>}
                  </select>
                  {!bankInfo && (
                    <p className="helper-text text-red-500">
                      Vui lòng cập nhật ngân hàng tại trang Cài đặt
                    </p>
                  )}
                  {bankInfo && (
                    <p className="helper-text">
                      Thay đổi tài khoản trong Cài đặt
                    </p>
                  )}
                </div>
                <button
                  type="submit"
                  className={`btn-primary w-full justify-center ${
                    !bankInfo ||
                    !amount ||
                    parseInt(amount) < 1000000 ||
                    parseInt(amount) > balance
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  disabled={
                    !bankInfo ||
                    !amount ||
                    parseInt(amount) < 1000000 ||
                    parseInt(amount) > balance
                  }
                >
                  Gửi yêu cầu
                </button>
              </form>
            </div>
          </div>

          {/* History Table */}
          <div className="aff-card" style={{ flex: "1", minWidth: "300px" }}>
            <div className="card-header">
              <h3>Lịch sử rút tiền</h3>
            </div>
            <div className="aff-table-container">
              <table>
                <thead>
                  <tr>
                    <th>Ngày yêu cầu</th>
                    <th>Số tiền</th>
                    <th>Trạng thái</th>
                    <th>Ghi chú</th>
                    <th>Chứng từ</th>
                  </tr>
                </thead>
                <tbody>
                  {payoutHistory.length > 0 ? (
                    payoutHistory.map((item) => (
                      <tr key={item.id}>
                        <td>{moment(item.createdAt).format("DD/MM/YYYY")}</td>
                        <td className="font-bold text-slate-800">
                          {formatCurrency(item.amount)} đ
                        </td>
                        <td>{getStatusBadge(item.status)}</td>
                        <td>
                          <small className="text-slate-500">
                            {item.admin_note || "-"}
                          </small>
                        </td>
                        <td>
                          {item.proof_image ? (
                            <a
                              href={`${END_POINT}${item.proof_image}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:underline"
                            >
                              <img
                                src={`${END_POINT}${item.proof_image}`}
                                alt="Proof"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                              />
                            </a>
                          ) : (
                            <span className="text-slate-400">-</span>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        Chưa có lịch sử rút tiền
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </AffiliateLayout>
  );
};

export default Payouts;
